import { render } from "./FooterAdmin.vue?vue&type=template&id=41b5f7b2"
import script from "./FooterAdmin.vue?vue&type=script&lang=js"
export * from "./FooterAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../var/www/html/fms_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__